import React, { createContext, useState, useEffect, useContext } from 'react'
import axios from 'axios'
import { useSearchAccesses } from './SearchAccessesContext'
import UserContext from './UserContext'

interface Profile {
  id: number
  name: string
  admin: boolean
  permissions: string[]
  createdAt: string
  updatedAt: string
}

interface ProfileContextProps {
  profiles: Profile[]
  setProfiles: React.Dispatch<React.SetStateAction<Profile[]>>
  fetchProfiles: () => Promise<void>
  newProfiles: number
  setNewProfiles: React.Dispatch<React.SetStateAction<number>>
  deletedProfile:number
  setDeletedProfile: React.Dispatch<React.SetStateAction<number>>
  loadQuantity:number
  setLoadQuantity: React.Dispatch<React.SetStateAction<number>>
  fetchProfilesWithoutAdmin: () => Promise<void>
}

interface ProfileProviderProps {
  children?: React.ReactNode
}

const ProfileContext = createContext<ProfileContextProps | undefined>(undefined)

export const ProfileProvider: React.FC<ProfileProviderProps> = ({ children }) => {
  const [profiles, setProfiles] = useState<Profile[]>([])
  const [newProfiles, setNewProfiles] = useState(0)
  const [deletedProfile, setDeletedProfile] = useState(0)
  const { searchText } = useSearchAccesses()
  const [loadQuantity, setLoadQuantity] = useState(5)

  const fetchProfiles = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/profile/findAll`, { params: { filter: searchText, loadQuantity: loadQuantity },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        }
      })
      setProfiles(response.data) 
    } catch (error) {
      console.error('Erro ao trazer os perfis', error)
    }
  }

  const fetchProfilesWithoutAdmin = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/profile/findAll`, { params: { filter: searchText, loadQuantity: loadQuantity },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        }
      })
      setProfiles(response.data.filter((profile: Profile) => profile.id !== 3)) // Filtrando para retirar o ADM da aba "Perfis"
    } catch (error) {
      console.error('Erro ao trazer os perfis', error)
    }
  }

  return (
    <ProfileContext.Provider value={{ profiles, setProfiles, fetchProfiles, newProfiles, setNewProfiles, deletedProfile, setDeletedProfile, loadQuantity, setLoadQuantity, fetchProfilesWithoutAdmin }}>
      {children}
    </ProfileContext.Provider>
  )
}

export const useProfileContext = () => {
  const context = useContext(ProfileContext)
  if (!context) {
    throw new Error('useProfileContext deve ser usado dentro de um ProfileProvider')
  }
  return context
}
